import { Fragment, useState } from 'react';
import playIcon from '@/assets/svg/play.png';
import styles from './index.module.scss';

export interface ScenarioCard {
  icon: string;
  title: string;
  description: string;
}

export interface ScenarioSectionProps {
  image: string;
  video?: string;
  cards: ScenarioCard[];
}

export default function ScenarioSection({ image, video, cards }: ScenarioSectionProps) {
  const [playing, setPlaying] = useState(false);
  const showVideo = playing && Boolean(video);
  const canPlay = Boolean(video) && !showVideo;

  const handlePlay = () => {
    if (!video) return;
    setPlaying(true);
  };

  return (
    <div className={styles.stage}>
      <div className={styles.frame}>
        <div
          className={canPlay ? `${styles.media} ${styles.mediaClickable}` : styles.media}
          onClick={handlePlay}
        >
          {showVideo ? (
            <video
              className={styles.video}
              src={video}
              poster={image}
              autoPlay
              controls
              playsInline
            />
          ) : (
            <>
              <img src={image} alt="多场景数字人" loading="lazy" />
              {canPlay ? (
                <span className={styles.play} aria-hidden>
                  <img src={playIcon} alt="" loading="lazy" />
                </span>
              ) : null}
            </>
          )}
        </div>
      </div>
      <div className={styles.cards}>
        {cards.map((card, index) => {
          return (
            <Fragment key={card.title}>
              {index > 0 ? <span className={styles.divider} aria-hidden /> : null}
              <div className={styles.card}>
                <img src={card.icon} alt="" className={styles.icon} loading="lazy" />
                <div className={styles.copy}>
                  <h3 className={styles.cardTitle}>{card.title}</h3>
                  <p className={styles.cardDescription}>{card.description}</p>
                </div>
              </div>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}
